var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 75.066,
    y1: 74.404,
    x2: 436.934,
    y2: 436.272,
    gradientTransform: "matrix(1 0 0 -1 0 511.338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#e81e25"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.108,
    style: {
      stopColor: "#ea3522"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    style: {
      stopColor: "#f1711c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.678,
    style: {
      stopColor: "#f59d17"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.881,
    style: {
      stopColor: "#f8b814"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f9c213"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.8 0 0 114.8 0 256s114.8 256 256 256 256-114.8 256-256S397.2 0 256 0zm0 484.2C130.2 484.2 27.8 381.8 27.8 256S130.2 27.8 256 27.8 484.2 130.2 484.2 256 381.8 484.2 256 484.2zm98.6-307.1L275.7 256l78.9 78.9c5.4 5.4 5.4 14.2 0 19.7-5.4 5.4-14.2 5.4-19.7 0L256 275.7l-78.9 78.9c-5.4 5.4-14.2 5.4-19.7 0-5.4-5.4-5.4-14.2 0-19.7l78.9-78.9-78.9-78.9c-5.4-5.4-5.4-14.2 0-19.7 5.4-5.4 14.2-5.4 19.7 0l78.9 78.9 78.9-78.9c5.4-5.4 14.2-5.4 19.7 0 5.4 5.5 5.4 14.3 0 19.7z",
    style: {
      fill: "url(#a)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.ae10283a0abad16510165056941a136c.svg";
export { ForwardRef as ReactComponent };